import { ThirdPartyBillingAccountSchema } from "@redotech/redo-fulfillment-carrier-account-common/third-party-billing-accounts";
import * as z from "zod";

export const getThirdPartyBillingAccounts = {
  name: "getThirdPartyBillingAccounts" as const,
  input: z.null(),
  output: z.object({ accounts: z.array(ThirdPartyBillingAccountSchema) }),
};
